import Image from "@Components/Image";
import config from "@Config/index";
import { AppState } from "@Store/index";
import { AMBER_USER_WEBSITE_CONFIGURABLE_COMPONENTS } from "constants/index";
import { shallowEqual, useSelector } from "react-redux";
import styles from "./SearchHeadingContent.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";

const ApplicationConfigBanner = () => {
  const { configComponents, regionId } = useSelector(
    ({ appData, searchPageData }: AppState) => ({
      configComponents: appData.configComponents,
      regionId: searchPageData?.region?.id,
    }),
    shallowEqual,
  );
  const { isWhitelabel } = useWhitelabel();

  const searchPageTopBannerConfig = configComponents?.filter(
    (configComponent: any) =>
      configComponent?.component_name ===
        AMBER_USER_WEBSITE_CONFIGURABLE_COMPONENTS["search_page_top_banner"] &&
      configComponent?.regionId === regionId,
  )[0];
  return searchPageTopBannerConfig ? (
    <span className={styles.searchPageConfigBanner}>
      <div className={styles.radialGradient1} />
      <div className={styles.radialGradient2} />
      <Image
        src={
          searchPageTopBannerConfig?.data?.image ||
          `${config.IMAGE_STATIC_URL}/configurable_components_images/timer-gif.gif`
        }
        height={48}
        width={48}
      />
      <div>
        <h3 className={formatClassNames(isWhitelabel ? "wl-title-font" : "", styles.title)}>
          {searchPageTopBannerConfig?.data?.title?.text || "default title"}{" "}
          <span className={styles.redText}>
            {searchPageTopBannerConfig?.data?.title?.highlighted_text || "default red text"}
          </span>
        </h3>
        <p className={styles.subTitle}>
          {searchPageTopBannerConfig?.data?.subtitle?.text || "default sub title"}
        </p>
      </div>
    </span>
  ) : (
    <></>
  );
};

export default wrapperHOC(ApplicationConfigBanner, {
  componentName: "SearchListContainer",
  showForChina: true,
});
